export default __webpack_public_path__ + "static/media/pdfImage.71e865f2.png";